import {
  QueryKey,
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient
} from 'react-query'

import {
  addAuctionToWatchList,
  deleteAuctionFromWatchList,
  deleteAutoBid,
  placeBid,
  readBids,
  setAutoBid
} from 'app/services/Api/auction'

import { listingKeys } from '../listing/listing.keys'
import { notificationKeys } from '../notification/notification.keys'

import { auctionKeys } from './auction.keys'

interface AuctionMutation {
  placeBid: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, PlaceBidDTO>
  }
  readBids: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, BidReadDTO>
  }
  addAuctionToWatchList: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, number>
  }
  deleteAuctionFromWatchList: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, string>
  }
  setAutoBid: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, SetMaxBidDTO>
  }
  deleteAutoBid: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, string>
  }
}

const auctionMutationConfig: AuctionMutation = {
  placeBid: {
    key: auctionKeys.placeBid(),
    request: placeBid
  },
  readBids: {
    key: auctionKeys.readBids(),
    request: readBids
  },
  addAuctionToWatchList: {
    key: auctionKeys.addAuctionToWatchList(),
    request: addAuctionToWatchList
  },
  deleteAuctionFromWatchList: {
    key: auctionKeys.deleteAuctionFromWatchList(),
    request: deleteAuctionFromWatchList
  },
  setAutoBid: {
    key: auctionKeys.setAutoBid(),
    request: setAutoBid
  },
  deleteAutoBid: {
    key: auctionKeys.deleteAutoBid(),
    request: deleteAutoBid
  }
}

export const usePlaceBidMutation = () => {
  const { placeBid: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(auctionKeys.auction)
      queryClient.invalidateQueries(listingKeys.listing)
      queryClient.invalidateQueries(notificationKeys.notification)
    }
  })

  return state
}

export const useReadBidsMutation = () => {
  const { readBids: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(auctionKeys.auction)
    }
  })

  return state
}

export const useAddAuctionToWatchList = () => {
  const { addAuctionToWatchList: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(listingKeys.listing)
    }
  })

  return state
}

export const useDeleteAuctionFromWatchList = () => {
  const { deleteAuctionFromWatchList: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(listingKeys.listing)
      queryClient.invalidateQueries(auctionKeys.auction)
    }
  })

  return state
}

export const useSetAutoBidMutation = () => {
  const { setAutoBid: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(listingKeys.listing)
      queryClient.invalidateQueries(auctionKeys.auction)
      queryClient.invalidateQueries(notificationKeys.notification)
    }
  })

  return state
}

export const useDeleteAutoBidMutation = () => {
  const { deleteAutoBid: config } = auctionMutationConfig
  const queryClient = useQueryClient()

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(auctionKeys.auction)
      queryClient.invalidateQueries(notificationKeys.notification)
    }
  })

  return state
}
